<template>
  <div class="side-panel">
    <v-layout white>
      <search-bar @search="filteredCows = filterTable(cows, $event)" :columns="headers"></search-bar>
      <v-spacer></v-spacer>
      <v-template v-if="false">
        <v-flex align-self-center shrink>
          <v-btn
            @click="createGroupModalVisible = true"
            class="secondary"
            medium>
            {{$t('roleDetails.createRole')}}
          </v-btn>
        </v-flex>
      </v-template>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="roles"
      :loading="roles.length === 0"
      hide-actions
    >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.item.roleID }}</td>
          <td class="text-xs-center">{{ $t(`roleNames.${props.item.role_type}`) }}</td>
        </template>
    </v-data-table>
  </div>
</template>

<script>
import RoleService from '@/services/RoleService'
import FilterTable from '@/helpers/FilterTable.js'

export default {
  mixins: [FilterTable],
  data () {
    return {
      headers: [
        {
          text: this.$t('roleGenerics.roleId'),
          align: 'center',
          sortable: false,
          value: 'name'
        },
        { text: this.$t('roleGenerics.roleName'),
          value: 'roleName',
          align: 'center'}
      ],
      roles: [],
      filteredCows: []
    }
  },
  async mounted () {
    this.roles = (await RoleService.index()).data
  }
}
</script>

<style scoped>
  tbody > tr {
    cursor: unset
  }
</style>



// WEBPACK FOOTER //
// src/components/Roles.vue